<div class="wos-wrapper">
  <app-header></app-header>
  <div class="wos-wrapper-content">
    <app-loader *ngIf="isLoading" [isFixed]="isFixed"></app-loader>
    <router-outlet></router-outlet>
    <app-svg-wrapper></app-svg-wrapper>
  </div>
</div>
